export default {
  myExam_score_total_score: '考試成績{score}分/{totalScore}分',
  myExam_no_chance:'考試機會已用完',
  myExam_still:'還有{remainNum}次考試機會',
  myExam_exam_ended:"考試已結束",
  myExam_test_num:'共{testNum}題',
  myExam_current_tab:'還沒有{currentTab}'
}
